var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},_vm._l((_vm.level),function(i){return _c('div',{key:i,staticClass:"w-3 h-3 rounded-full mr-1",class:("bg-" + _vm.color + "-300")})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }